const TemplateName = {
    
    Data_Balance_Details:'Data_Balance_Details',
    Outstanding_Amount:'Outstanding_Amount',
    CURRENT_BILL_PLAN:'CURRENT_BILL_PLAN',
    Eligible_Bill_Plans:'Eligible_Bill_Plans',
    New_Bill_Plan:'New_Bill_Plan',
    PAY_MY_BILL:'PAY_MY_BILL',
    PREV_DUPLICATE_BILLS:'PREV_DUPLICATE_BILLS',
    PREV_PAYMENT_RECEIPTS:'PREV_PAYMENT_RECEIPTS',
    IR_ACTIVATED_PACKS_DEACTIVATION:'IR_ACTIVATED_PACKS_DEACTIVATION',
    IR_MULTIPLE_ZONE_PACKS:'IR_MULTIPLE_ZONE_PACKS',
    IR_SINGLE_ZONE_PACKS:'IR_SINGLE_ZONE_PACKS',
    IR_Pack_Countries: "IR_Pack_Countries",
    IR_PACKS_RECO: "IR_PACKS_RECO",
    IR_RECO_DYN_PARAM: "IR_RECO_DYN_PARAM",
    IR_PACKS_ALL: "IR_PACKS_ALL",
    IR_SERVICE_DEACTIVATION:"IR_SERVICE_DEACTIVATION"

}

export default TemplateName


// WEBPACK FOOTER //
// ./src/enums/templateName.js